import { create } from 'zustand'
import type { ItemCustomsSummaryDto } from '@crm/shared'

/**
 * Какая позиция открыта в окне «Ответ брокера» карточки заявки (с 30.10.2026):
 * ячейки нетарифки открывают окно по клику, само окно — одно на таблицу (ItemsGrid).
 */
interface CustomsAnswerViewState {
  open: { partNumber: string; customs: ItemCustomsSummaryDto } | null
  show: (partNumber: string, customs: ItemCustomsSummaryDto) => void
  close: () => void
}

export const useCustomsAnswerView = create<CustomsAnswerViewState>((set) => ({
  open: null,
  show: (partNumber, customs) => set({ open: { partNumber, customs } }),
  close: () => set({ open: null }),
}))
